/**
 * BAZAR PRO - IMMERSIVE INTERACTIONS
 * Lightweight parallax + Intersection Observer
 * Performance-first approach
 */

(function() {
  'use strict';

  // Check if reduced motion is preferred
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Intersection Observer for fade-in animations
   */
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    
    if (!animatedElements.length) return;

    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Unobserve after animation to improve performance
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animatedElements.forEach(element => {
      observer.observe(element);
    });
  }

  /**
   * Subtle parallax effect on image
   * Desktop only, lightweight transform
   */
  function initParallax() {
    if (prefersReducedMotion) return;
    if (window.innerWidth < 1024) return; // Desktop only

    const parallaxElements = document.querySelectorAll('[data-parallax]');
    
    if (!parallaxElements.length) return;

    let ticking = false;
    const maxTranslate = 30; // Maximum 30px translate

    function updateParallax() {
      const scrolled = window.pageYOffset;
      
      parallaxElements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + scrolled;
        const elementHeight = rect.height;
        const windowHeight = window.innerHeight;
        
        // Only apply when element is in viewport
        if (scrolled + windowHeight > elementTop && scrolled < elementTop + elementHeight) {
          // Calculate parallax offset
          const relativeScroll = (scrolled + windowHeight - elementTop) / (windowHeight + elementHeight);
          const translateY = (relativeScroll - 0.5) * maxTranslate;
          
          element.style.transform = `translateY(${translateY}px)`;
        }
      });
      
      ticking = false;
    }

    function requestParallaxUpdate() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    // Throttled scroll listener
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      if (scrollTimeout) {
        window.cancelAnimationFrame(scrollTimeout);
      }
      scrollTimeout = window.requestAnimationFrame(requestParallaxUpdate);
    }, { passive: true });

    // Initial call
    updateParallax();
  }

  /**
   * Reinitialize on section load (Shopify section rendering)
   */
  function init() {
    // Small delay to ensure DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initScrollAnimations();
        initParallax();
      });
    } else {
      initScrollAnimations();
      initParallax();
    }
  }

  // Initialize
  init();

  // Reinitialize on Shopify section events
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }

})();
